export const SAMPLE_INFINITIES = [
	// eslint-disable-next-line unicorn/prefer-number-properties
	-Infinity,
	Number.NEGATIVE_INFINITY,
	// eslint-disable-next-line unicorn/prefer-number-properties
	Infinity,
	Number.POSITIVE_INFINITY,
] as const;
